import { mapActions, mapGetters } from 'vuex';
import { snakeToTitle } from 'helpers/strings.js';

export default {
    computed: {
        ...mapGetters('search_filters', [
            'filters',
            'getFilter',
        ]),
    },

    beforeMount() {
        if ( !this.namespace ) {
            console.error(`this.namespace not set in ${this.$options.name}`);
        }

        if ( !(this.namespace in this.filters) ) {
            this.setNamespace(this.namespace);
        }
    },

    methods: {
        ...mapActions('search_filters', [
            'clearFilter',
            'clearFilterNamespace',
            'setFilter',
            'setNamespace',
        ]),

        unsetComputedFromFilter({key}) {
            this.clearFilter({ namespace: this.namespace, which: key });
        },

        getFilterValue(filter_key) {
            return this.getFilter(this.namespace, filter_key)?.filter_value || null;
        },

        /**
         *
         * @param {string} filter_key
         * @param {object|string} filter_value
         * @param {string} [filter_label=filter_value]
         * @param {string|false} [filter_name=filter_key] false = hide filter in SearchFiltersDisplay
         * @param {boolean} [title_case=true]
         */
        setFilterValue(filter_key, filter_value, filter_label = filter_value, filter_name = filter_key, title_case = true) {
            if ( [undefined, null, '', {}].includes(filter_value) || filter_value.length === 0 ) {
                this.unsetComputedFromFilter({ key: filter_key });

            } else {
                if ( title_case ) {
                    filter_label = snakeToTitle(String(filter_label));
                }

                if ( filter_name !== false ) {
                    filter_name = snakeToTitle(filter_name);
                }

                this.setFilter({
                    namespace: this.namespace,
                    which: filter_key,
                    value: { filter_key, filter_value, filter_label, filter_name },
                });
            }
        },
    }
};
